import NotificationTemplate, {
  NotificationTemplateEntity,
} from 'src/firebase/db/NotificationTemplates';

export const getNotificationTemplates = (payload: {
  shopId: string;
  templateIds: string[] | undefined;
}) => {
  return NotificationTemplate.getNotificationTemplates(payload);
};

export const getNotificationTemplate = (notificationTemplateId: string) => {
  return NotificationTemplate.getNotificationTemplate(notificationTemplateId);
};

export const createNotificationTemplate = (query: NotificationTemplateEntity) =>
  NotificationTemplate.create(query);

export const updateNotificationTemplate = (query: NotificationTemplateEntity) =>
  NotificationTemplate.update(query);

export const deleteNotificationTemplate = (notificationTemplateId: string) =>
  NotificationTemplate.delete(notificationTemplateId);
